import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=39ed459d&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=39ed459d&scoped=true&lang=css&"
import style1 from "./index-phone.css?vue&type=style&index=1&id=39ed459d&scoped=true&lang=css&"
import style2 from "./loading-box.css?vue&type=style&index=2&id=39ed459d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed459d",
  null
  
)

export default component.exports